import { Box, Container, IconButton, Typography } from '@material-ui/core';
import AlertIcon from 'assets/icons/AlertIcon';
import './AlertCard.scss';
import AlertBarraBox from 'assets/icons/AlertBarraBox';
import AlertArrowRight from 'assets/icons/AlertArrowRight';
import { useLocation, Link } from 'react-router-dom';
import languageValues from 'utils/LanguageUtils';

interface AlertCardProps {
  showAlert: boolean;
}

export const AlertCard = ({ showAlert }: AlertCardProps) => {
  const { pathname } = useLocation();
  const isEscolasRoute = pathname === '/programaseducacionais/admin/escolas';

  const alertText = isEscolasRoute
    ? languageValues.components.AlertCard.camposObrigatoriosRequired
    : languageValues.components.AlertCard.camposObrigatoriosRequiredCadastroEscolas;
  const alertLinkText = isEscolasRoute ? '' : languageValues.components.AlertCard.VerTodasAsEscolas
  const alertRoutePath = isEscolasRoute ? '' : '/programaseducacionais/admin/escolas';
  const shouldShowArrow = !isEscolasRoute;

  if (!showAlert) return null;

  return (
    <Container maxWidth='xl' id='container_box'>
      <Box maxWidth={'sm'} className='alert-card-container'>
        <AlertBarraBox />
        <Box className='content-container'>
          <AlertIcon />
          <Typography className='alert_card_text'>{alertText}</Typography>
          <Box display='flex' alignItems='left'>
            <Link to={alertRoutePath || '#'}>
              {shouldShowArrow && (
                <IconButton size='small' className='alert_container_arrow'>
                  <div className='alert_card_text_link'>{alertLinkText}</div>
                  <div className='alert_icon_arrow'>
                    <AlertArrowRight />
                  </div>
                </IconButton>
              )}
            </Link>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};